import React, { Component } from "react";
import SchoolBrief from "./components/SchoolBrief";
import SchoolSubject from "./components/SchoolSubject";
import SchoolContact from "./components/SchoolContact";
import { getQueryValue } from "../../../../utils/tool";
import "./style.css";
import "../../../../index.css";
class SchoolDetailDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markArray: [true, false, false],
      css: {
        right: "13px",
      },
    };
  }
  componentDidMount() {
    this.fixCss();
    if (getQueryValue("from") === "majorquery/list") {
      this.setState({
        markArray: [false, true, false],
      });
    }
  }
  render() {
    const { data, hashId,from } = this.props;
    const { markArray, css } = this.state;
    return data === null ? (
      ""
    ) : (
      <div className="schoolDetailDown_box">
        <div className="schoolDetailDown_box_switch">
          <div
            onClick={() => this.activateTab(0)}
            className={
              markArray[0] === true
                ? "schoolDetailDown_box_switch_active fl"
                : "fl"
            }
          >
            学校简介
          </div>
          {/* <div
            onClick={() => this.activateTab(1)}
            className={
              markArray[1] === true
                ? "schoolDetailDown_box_switch_active fl"
                : "fl"
            }
          >
            专业/选科
          </div> */}
          <div
            style={{ position: "relative" }}
            onClick={() => this.activateTab(2)}
            className={
              markArray[2] === true
                ? "schoolDetailDown_box_switch_active fl"
                : "fl"
            }
          >
            <img
              style={{ right: css.right !== "13px" ? css.right : "13px" }}
              alt=""
              className="schoolDetailDown_box_switch_hot"
              src={require("../../../../images/school/hot.gif")}
            ></img>
            联系方式
          </div>
          <div className="clear"></div>
        </div>
        <div className="schoolDetailDown_box_content">
          <SchoolBrief
            data={data}
            visible={this.state.markArray[0]}
          ></SchoolBrief>
          <SchoolSubject
            data={data}
            hashId={hashId}
            visible={this.state.markArray[1]}
            type="school"
            from={from}
          ></SchoolSubject>
          <SchoolContact
            data={data}
            visible={this.state.markArray[2]}
          ></SchoolContact>
        </div>
        <div
          style={{ height: this.state.markArray[1] === true ? 43 : 63 }}
        ></div>
      </div>
    );
  }
  fixCss = () => {
    let minWidth = window.innerWidth;
    if (minWidth === 414 || minWidth === 411) {
      this.setState({
        css: {
          right: "20px",
        },
      });
    } else if (minWidth === 320) {
      this.setState({
        css: {
          right: "9px",
        },
      });
    } else if (minWidth >= 750) {
      this.setState({
        css: {
          right: "78px",
        },
      });
    }
  };
  activateTab = (id) => {
    let tmpMarkArray = [false, false, false];
    tmpMarkArray[id] = true;
    this.setState({ markArray: tmpMarkArray });
  };
}

export default SchoolDetailDown;



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolDetailDown/index.js